<template>
  <div class="payment-status" v-cloak>
    <!--失败时: 用icon-iconfontguanbi fail替换icon-duihao2 bg-color-red-->
    <div
      class="iconfont icon-duihao2 bg-color-red"
      v-if="!isWeixin || orderInfo.paid || orderInfo.pay_type == 'offline'"
    ></div>
    <div class="iconfont icon-iconfontguanbi fail" v-else></div>
    <!-- 失败时:订单支付失败 -->
    <div class="status" v-if="!is_complete">{{$t('message.order.tip_create_order')}}</div>
    <div class="status" v-else-if="orderInfo.paid">{{$t('message.order.payment_succeeded')}}</div>
    <div class="status" v-else>{{$t('message.order.payment_fail')}}</div>

    <div class="wrapper">
      <div class="item acea-row row-between-wrapper">
        <div>{{$t('message.order.order_no')}}</div>
        <div class="itemCom" v-text="orderInfo.order_id"></div>
      </div>
      <div class="item acea-row row-between-wrapper">
        <div>{{$t('message.order.order_time')}}</div>
        <div class="itemCom" v-text="orderInfo.add_time"></div>
      </div>
      <div class="item acea-row row-between-wrapper">
        <div>{{$t('message.order.payment_method')}}</div>
        <div class="itemCom" v-if="orderInfo.pay_type == 'yue'">{{$t('message.order.pay_via_balance')}}</div>
        <div class="itemCom" v-else>{{$t('message.order.other')}}</div>
      </div>
      <div class="item acea-row row-between-wrapper">
        <div>{{$t('message.order.total_amount')}}</div>
        <div class="itemCom" v-text="orderInfo.pay_price"></div>
      </div>
      <!--失败时加上这个  -->
      <div
        class="item acea-row row-between-wrapper"
        v-if="orderInfo.paid == 0 && msgContent"
      >
        <div>{{$t('message.order.failure_reason')}}</div>
        <div class="itemCom" v-text="msgContent"></div>
      </div>
    </div>
    <!--失败时: 重新购买 -->
    <div v-if="orderInfo.pay_type == 'weixin' && orderInfo.is_channel == 2">
      <div class="returnBnt bg-color-red" @click="goPages()">{{$t('message.order.view_payment_results')}}</div>
      <div class="returnBnt cart-color" @click="goPages()">
        {{$t('message.order.payment_failed_to_repay')}}
      </div>
    </div>
    <div v-if="orderInfo.paid==1">
      <div class="returnBnt bg-color-red" @click="goGame()">{{$t('message.order.hot_spot')}}®</div>
      <!--<div class="returnBnt bg-color-red" @click="goPages()">查看订单</div>-->
      <!--<div class="returnBnt cart-color" @click="goPages('/')">返回首页</div>-->
    </div>
    <div v-if="orderInfo.paid==0">
      <!--<div class="returnBnt bg-color-red" @click="goGame()">参与抽奖</div>-->
      <div class="returnBnt bg-color-red" @click="$router.replace({path:'/user/account'})">{{$t('message.order.top_up')}}</div>
      <div class="returnBnt cart-color" @click="goPages('/')">{{$t('message.order.back_home')}}</div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { orderDetail } from "@api/order";
import { get_game_config } from "@api/game";
import { isWeixin } from "@utils";

const NAME = "PayMentStatus";

export default {
  name: NAME,
  props: {},
  data: function() {
    return {
      id: "",
      is_complete:false,
      status: 0,
      msgContent: "",
      game_type:'',
      orderInfo: {},
      gameType:'',
      gameId:0, //默认猜大小
      isWeixin: isWeixin()
    };
  },
  watch: {
    $route(n) {
      if (n.query.msg) this.msgContent = n.query.msg;
      if (n.query.game) this.gameId = n.query.game;
      if (n.name === NAME && this.id !== n.params.id) {
        this.id = n.params.id;
        this.status = parseInt(n.params.status);
        this.getOrderInfo();
      }
    }
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  mounted() {
    this.id = this.$route.params.id;
    this.msgContent = this.$route.query.msg;
    // this.game_type = this.$route.query.game;
    this.status = parseInt(this.$route.params.status);
    this.getOrderInfo();
  },
  methods: {
    goGame(){
      switch (this.gameId) {
        case 24:this.$router.replace({path:'/order/game/likeNum',query:{id:this.id,gameName:this.gameType,game_id:this.gameId}});break;
        case 28:this.$router.replace({path:'/order/game/number',query:{id:this.id,gameName:this.gameType,game_id:this.gameId}});break;
      }
    },
    goPages(route) {
      let routes =
        route !== undefined
          ? route
          : "/order/detail/" + this.orderInfo.order_id;
      if (this.status === 5 && route === undefined) routes = "/order/list/0";
      return this.$router.replace({
        path: routes
      });
    },
    getOrderInfo() {
      this.$dialog.loading.open('Loading...')

      orderDetail(this.id).then(res => {
        this.$dialog.loading.close()
        this.orderInfo = res.data;
        this.is_complete = true
        if (this.isWeixin) {
          document.title = this.orderInfo.paid ? this.$t('message.order.payment_succeeded') : this.$t('message.order.payment_fail');
        } else {
          document.title = this.$t('message.order.msg_create_success');

        }
      }).catch(res=>{
        this.$dialog.loading.close()
        this.is_complete = true
      })

      get_game_config(this.id).then(res=>{
        this.$dialog.loading.close()
        // console.log('获取的游戏类型',res)
        this.gameId = res.data.game_id
        this.gameType = res.data.game_type
      })
              .catch(res=>{
                this.$dialog.loading.close()

              })
    }
  }
};
</script>
